export default {"src":"/planos/_next/static/media/equifax-user-business.3ad75647.svg","height":21,"width":28,"blurWidth":0,"blurHeight":0};